<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';
import { useTimeAgo } from 'dashboard/composables/useTimeAgo';

const props = defineProps({
  selectedContact: {
    type: Object,
    required: true,
  },
  rfmSegment: {
    type: Object,
    default: null,
  },
  showRfm: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();
const route = useRoute();
const { timeAgo } = useTimeAgo();

const conversationsGetter = useMapGetter(
  'contactConversations/getAllConversationsByContactId'
);

const conversationsCount = computed(
  () => (conversationsGetter.value(route.params.contactId) || []).length
);

const createdAt = computed(
  () => timeAgo(props.selectedContact?.createdAt) || '-'
);

const lastActivityAt = computed(
  () => timeAgo(props.selectedContact?.lastActivityAt) || '-'
);
</script>

<template>
  <div class="flex flex-col gap-3">
    <div v-if="showRfm && rfmSegment" class="flex items-center gap-2">
      <span class="w-28 text-sm shrink-0 text-n-slate-11">
        {{ t('CONTACTS_LAYOUT.DETAILS.FIELDS.RFM') }}
      </span>
      <span
        class="inline-flex items-center px-2 py-0.5 text-xs font-medium text-white rounded-full"
        :style="{ backgroundColor: rfmSegment.color }"
      >
        {{ rfmSegment.label }}
      </span>
    </div>
    <div class="flex items-start gap-2">
      <span class="w-28 text-sm shrink-0 text-n-slate-11">
        {{ t('CONTACTS_LAYOUT.OVERVIEW.CONVERSATIONS_COUNT') }}
      </span>
      <span class="text-sm text-n-slate-12">{{ conversationsCount }}</span>
    </div>
    <div class="flex items-start gap-2">
      <span class="w-28 text-sm shrink-0 text-n-slate-11">
        {{ t('CONTACTS_LAYOUT.DETAILS.FIELDS.CREATED_AT') }}
      </span>
      <span class="text-sm text-n-slate-12">{{ createdAt }}</span>
    </div>
    <div class="flex items-start gap-2">
      <span class="w-28 text-sm shrink-0 text-n-slate-11">
        {{ t('CONTACTS_LAYOUT.DETAILS.FIELDS.LAST_ACTIVITY') }}
      </span>
      <span class="text-sm text-n-slate-12">{{ lastActivityAt }}</span>
    </div>
  </div>
</template>
